import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'

// Set up a global variable to indicate React has loaded
declare global {
  interface Window {
    reactLoaded: boolean;
  }
}

const rootElement = document.getElementById('root');
if (rootElement) {
  try {
    const root = createRoot(rootElement);
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
    
    // Signal that React has successfully loaded
    window.reactLoaded = true;
    console.log('React app mounted successfully');
  } catch (error) {
    console.error('Error rendering app:', error);
    // If there's an error loading React, make sure the fallback content is visible
    document.documentElement.classList.remove('js-loaded');
  }
} else {
  console.error('Root element not found');
  document.documentElement.classList.remove('js-loaded');
}
